import { useEffect } from 'react';
import Page from '../../../components/page/Page';
import { Paper } from '@mui/material';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { useNavigationCore } from '../../../../core/router/navigation';
import { useMeCore } from '../../../../core/modules/me';
import { useMasterCore } from '../../../../core/modules/master';
import { useCompanyCore } from '../../../../core/modules/company';
import Header from '../../../components/queries/containers/Header';
import { useBusinessCore } from '../../../../core/modules/business';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const Containers = () => {
  const { user } = useMeCore();
  const { companyId } = useCompanyCore();
  const { getCategories, getTypes, getPriceRanges } = useMasterCore();
  const { goToWelcome } = useNavigationCore();
  const { getBusinesses } = useBusinessCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (
      !user || !user.privileges.superAdmin
    ) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    if (companyId) {
      getTypes(companyId, 'container');
      getCategories(companyId, 'container');
      getPriceRanges(companyId);
    }
  }, [companyId, getBusinesses, getCategories, getPriceRanges, getTypes]);

  const columns: GridColDef[] = [
    {
      field: 'destiny',
      headerName: 'C. DESTINO',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'sku1',
      headerName: 'SKU 1',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'sku2',
      headerName: 'SKU 2',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'description',
      headerName: 'Descripción',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'origin',
      headerName: 'C. Origen',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'provider',
      headerName: 'Proveedor',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'location',
      headerName: 'Ubicación',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'store',
      headerName: 'Bodega',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'quantity',
      headerName: 'Cant.',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'price',
      headerName: 'Precio',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'category',
      headerName: 'Categoría',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
    {
      field: 'reception',
      headerName: 'N. Recepción',
      cellClassName: 'flex items-center p-8',
      flex: 1,
    },
  ];

  return (
    <>
      <Page
        header={<Header />}
        content={
          <div className="w-full my-16 px-24 md:px-32">
            <Paper className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden">
              <div className="w-full p-32">
                <DataGrid
                  rows={[]}
                  columns={columns}
                  sx={{ border: 0 }}
                  disableColumnSorting
                  disableColumnFilter
                  disableRowSelectionOnClick
                  disableMultipleRowSelection
                  hideFooter
                  getRowHeight={() => 'auto'}
                  pagination={undefined}
                />
              </div>
            </Paper>
          </div>
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
    </>
  );
};

export default Containers;
